
import {gql} from 'apollo-angular';

export const gameInactivatedSubscription = gql`
  subscription subscribeToOnJeopardyGameInactivated($gameId: Int!) {
    jeopardyGameInactivated(gameId: $gameId) {
      gameId
    }
  }
`;

export const beforeRoundStartedSubscription = gql`
  subscription subscribeToOnBeforeRoundStart($gameId: Int!) {
    round:beforeRoundStart(gameId: $gameId) {
      gameId,
      roundId,
      roundNumber,
      timeStart,
      timeEnd,
      activeUser {
        deviceIdentifier
        deviceDetected
        avatar
        score
        connected
        language
        location
        playInactivityCounter
        playingTime
        userId
        name
        jokerSkip
        jokerFiftyFifty
      },
      question {
        questionId
        umbracoQuestionId
        points
        topicId
        timer
      }
    }
  }
`;

export const roundStartedSubscription = gql`
  subscription subscribeToOnRoundStarted($gameId: Int!) {
    round:roundStarted(gameId: $gameId) {
      gameId,
      roundId,
      roundNumber,
      timeStart,
      timeEnd,
      activeUser {
        deviceIdentifier
        deviceDetected
        avatar
        score
        connected
        language
        location
        playInactivityCounter
        playingTime
        userId
        name
        jokerSkip
        jokerFiftyFifty
      },
      question {
        questionId
        umbracoQuestionId
        points
        topicId
        timer
      }
    }
  }
`;

export const roundEndedSubscription = gql`
  subscription subscribeToOnRoundEnded($gameId: Int!) {
    round:roundEnded(gameId: $gameId) {
      gameId
      roundId
      roundNumber
      timeStart
      timeEnd
      activeUserId
      activeUser {
        deviceIdentifier
        deviceDetected
        avatar
        score
        connected
        language
        location
        playInactivityCounter
        playingTime
        userId
        name
        jokerSkip
        jokerFiftyFifty
      }
      question {
        questionId
        umbracoQuestionId
        points
        topicId
        timer
      }
    }
  }
`;

export const userIdleSubscription = gql`
  subscription subscribeToOnJeopardyUserIdleDetected($gameId: Int!) {
    user:jeopardyUserIdleDetected(gameId: $gameId) {
      gameId
      host
      avatar
      deviceDetected
      deviceIdentifier
      jokerFiftyFifty
      jokerSkip
      name
      language
      location
      score
      userId
      playInactivityCounter
      playingTime
    }
  }
`;

export const userIdleDisconnectedSubscription = gql`
  subscription subscribeToOnJeopardyUserIdleDisconnected($gameId: Int!) {
    user:jeopardyUserIdleDetected(gameId: $gameId) {
      gameId
      host
      avatar
      deviceDetected
      deviceIdentifier
      jokerFiftyFifty
      jokerSkip
      name
      language
      location
      score
      userId
      playInactivityCounter
      playingTime
    }
  }
`;

export const userConnectedSubscription = gql`
  subscription subscribeToOnJeopardyUserConnected($gameId: Int!) {
    user:jeopardyUserConnected(gameId: $gameId) {
      # gameId
      host
      avatar
      deviceDetected
      deviceIdentifier
      jokerFiftyFifty
      jokerSkip
      name
      language
      location
      score
      userId
      playInactivityCounter
      playingTime
      connected
    }
  }
`;

export const userScoreUpdatedSubscription = gql`
  subscription subscribeToOnUserScoreUpdated($gameId: Int!) {
    user:userScoreUpdated(gameId: $gameId) {
      gameId
      host
      avatar
      deviceDetected
      deviceIdentifier
      jokerFiftyFifty
      jokerSkip
      name
      language
      location
      score
      userId
      playInactivityCounter
      playingTime
    }
  }
`;

export const expiringRoundSubscription = gql`
  subscription subscribeToOnBeforeRoundStart($gameId: Int!) {
    beforeRoundStart(gameId: $gameId) {
      gameId
      roundId
      roundNumber
      remainingAnswerTime
    }
  }
`;